export default __webpack_public_path__ + "static/media/icon-brand-paypal.c548737f.svg";